// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I2jR","name":"styles_name__jYA1C","phone":"styles_phone__TqviU"};